/**
 * Hook para aceptar términos y condiciones.
 */
import { useMutation, useQueryClient, UseMutationResult } from "react-query";
import { config } from "common/config";
import { Queries } from "ui/query/queries";
import { organizationTermsApi } from "../api/organizationTermsApi";

export function useAcceptTermsAndConditions(
    options?: { onSuccess?: () => void }
): UseMutationResult<void, unknown, void> {
    const queryClient = useQueryClient();
    const organizationAddress = config.organization.address;

    return useMutation(
        async () => {
            await organizationTermsApi.acceptTermsAndConditions(organizationAddress);
        },
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries([Queries.USER_INFO]);
                queryClient.invalidateQueries([Queries.GET_ORGANIZATION_INFO]);
                options?.onSuccess?.();
            },
        }
    );
}
